// FETCH ALL PROCESS_ADD_ON
export const FETCH_PROCESS_ADD_ON_REQUEST = 'FETCH_PROCESS_ADD_ON_REQUEST';
export const FETCH_PROCESS_ADD_ON_SUCCESS = 'FETCH_PROCESS_ADD_ON_SUCCESS';
export const FETCH_PROCESS_ADD_ON_FAILURE = 'FETCH_PROCESS_ADD_ON_FAILURE';
// FETCH ALL PROCESS_ADD_ON
export const FETCH_PROCESS_ADD_ON_SALESORDER_REQUEST = 'FETCH_PROCESS_ADD_ON_SALESORDER_REQUEST';
export const FETCH_PROCESS_ADD_ON_SALESORDER_SUCCESS = 'FETCH_PROCESS_ADD_ON_SALESORDER_SUCCESS';
export const FETCH_PROCESS_ADD_ON_SALESORDER_FAILURE = 'FETCH_PROCESS_ADD_ON_SALESORDER_FAILURE';

// CREATE PROCESS_ADD_ON
export const CREATE_PROCESS_ADD_ON_REQUEST = 'CREATE_PROCESS_ADD_ON_REQUEST';
export const CREATE_PROCESS_ADD_ON_SUCCESS = 'CREATE_PROCESS_ADD_ON_SUCCESS';
export const CREATE_PROCESS_ADD_ON_FAILURE = 'CREATE_PROCESS_ADD_ON_FAILURE';

// UPDATE PROCESS_ADD_ON
export const UPDATE_PROCESS_ADD_ON_REQUEST = 'UPDATE_PROCESS_ADD_ON_REQUEST';
export const UPDATE_PROCESS_ADD_ON_SUCCESS = 'UPDATE_PROCESS_ADD_ON_SUCCESS';
export const UPDATE_PROCESS_ADD_ON_FAILURE = 'UPDATE_PROCESS_ADD_ON_FAILURE';

// FETCH SINGLE STATE OF PROCESS_ADD_ON
export const FETCH_SINGLE_PROCESS_ADD_ON_REQUEST = 'FETCH_SINGLE_PROCESS_ADD_ON_REQUEST';
export const FETCH_SINGLE_PROCESS_ADD_ON_SUCCESS = 'FETCH_SINGLE_PROCESS_ADD_ON_SUCCESS';
export const FETCH_SINGLE_PROCESS_ADD_ON_FAILURE = 'FETCH_SINGLE_PROCESS_ADD_ON_FAILURE';

// DELETE PROCESS_ADD_ON
export const DELETE_PROCESS_ADD_ON_REQUEST = 'DELETE_PROCESS_ADD_ON_REQUEST';
export const DELETE_PROCESS_ADD_ON_SUCCESS = 'DELETE_PROCESS_ADD_ON_SUCCESS';
export const DELETE_PROCESS_ADD_ON_FAILURE = 'DELETE_PROCESS_ADD_ON_FAILURE';

export const RESET_PROCESS_ADD_ON_INFO = 'RESET_PROCESS_ADD_ON_INFO';

export const CREATE_PROCESS_ADD_ON_FORM = 'CREATE_PROCESS_ADD_ON_FORM';

export const UPDATE_PROCESS_ADD_ON_FORM = 'UPDATE_PROCESS_ADD_ON_FORM';
